// localStorage keys that hold identity / credentials. Anything listed here is
// wiped on logout via clearSession(). Keep this the single source of truth for
// "what we persist about the signed-in user".
export const STORAGE_KEYS = {
  USER_INFO: "userInfo",
  MEDIA_LIBRARY_TOKEN: "mediaLibraryUploaderToken",
}

// Remove all identity/credential data from local storage. Idempotent — safe to
// call on every logout path (button, token-expiry, refresh failure, init error).
export const clearSession = () => {
  localStorage.removeItem(STORAGE_KEYS.USER_INFO)
  localStorage.removeItem(STORAGE_KEYS.MEDIA_LIBRARY_TOKEN)
}
